import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { FlyoverSliceState } from './flyover.type';

const flyoverInitialState: FlyoverSliceState = {
    data: null,
};

export const FLYOVER_REDUCER_NAME = 'flyover';

export const flyoverSlice = createSlice({
    name: FLYOVER_REDUCER_NAME,
    initialState: flyoverInitialState,
    reducers: {
        setFlyover: (
            state,
            action: PayloadAction<FlyoverSliceState['data']>,
        ) => {
            state.data = action.payload;
        },
    },
});

export const { setFlyover } = flyoverSlice.actions;

export const flyoverReducer = flyoverSlice.reducer;
